module.exports = "<div>\r\n    <div ncy-breadcrumb class=\"breadcrumb-container\">\r\n    </div>\r\n</div>";